import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 px-4 bg-white" data-id="element-67">
      <div className="max-w-3xl mx-auto bg-brand-surface border border-brand-border rounded-xl p-8 flex flex-col md:flex-row items-center gap-6 text-center md:text-left" data-id="element-68">
        <div className="flex-shrink-0" data-id="element-69">
          <ShieldCheck className="w-20 h-20 text-brand-green" data-id="element-70" />
        </div>
        <div data-id="element-71">
          <h3 className="text-2xl font-bold text-brand-text mb-2" data-id="element-72">
            Garantía Incondicional de 7 Días
          </h3>
          <p className="text-brand-muted" data-id="element-73">
            Estamos tan seguros de que este manual transformará tu forma de
            jugar, que te ofrecemos 7 días de garantía. Si sentís que el
            contenido no te aporta valor, te devolvemos el 100% de tu dinero sin
            hacer preguntas.
          </p>
        </div>
      </div>
    </section>;
}